/* eslint-disable complexity */
/* eslint-disable max-statements */
/* eslint-disable consistent-return */
import React, { useState, useEffect, useRef, Fragment } from 'react';
import axios from 'axios';
import constants from '../../constants';
import { cookieStorageUtility } from '../../utils/utilityFunctions';
import { checkRole } from '../Common/CheckRole';
import { Link } from 'react-router-dom';

const { serverUrl, ENCRYPTOR_KEY } = constants;
const authUserId = cookieStorageUtility.fetch('auth_user_id');
const encryptedToken = cookieStorageUtility.fetch('encrypted_' + ENCRYPTOR_KEY + '_token');

const Dashboard = (props) => {
  const [paymentLog, setPaymentLog] = useState({ charge_log: [], can_retry: false });
  const [bookingId, setBookingId] = useState('');
  const [flag, setFlag] = useState(false);
  const [showSearchLoader, setShowSearchLoader] = useState(false);
  const [type, setType] = useState('error');
  const [message, setMessage] = useState('');
  const [showUILoader, setShowUILoader] = useState(true);
  const [showPopup, setShowPopup] = useState(false);
  const [blockChannel, setBlockChannel] = useState(true);
  const [noData, setNoData] = useState(false);

  const handleValueChange = (e) => {
    setBookingId(e.target.value);
  };
   const handleFiles = (files) => {
    const _file = files.target.files[0];
    var reader = new FileReader();
    reader.onload = e => {
      // console.log(reader.result);
    };
    reader.readAsText(_file);
    let formData = new FormData();
    formData.append('file', _file);
    setShowUILoader(true);
    axios(serverUrl + 'payment/bulk_reinitiate_charge', {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'multipart/form-data',
        token: btoa(authUserId + '|' + encryptedToken)
      },
      data: formData
    })
      .then(response => {
        if (response.data.status === 'success') {
          showMessage('success', response.data.message);
        } else {
          showMessage('error', response.data.message);
        }
        setShowUILoader(false);
      })
      .catch(error => {
        console.log(error);
        setShowUILoader(false);
      });
  };
//   const handleFiles = async (e) => {
//   const file = e.target.files[0];
//   if (!file) return;

//   const formData = new FormData();
//   formData.append("file", file);

//   try {
//     const res = await axios.post(
//      `${serverUrl}payment/bulk_reinitiate_charge`,
//       formData,
//       {
//         headers: {
//           "Content-Type": "multipart/form-data", // axios needs this
//         },
//       }
//     );

//     console.log("Upload success:", res.data);
//   } catch (err) {
//     console.error("Upload error:", err.response?.data || err.message);
//   }
// };

  const showMessage = (type, msg) => {
    setFlag(true);
    setType(type);
    setMessage(msg);
    setTimeout(() => setFlag(false), 5000);
  };

  const blockChannelFunction = (response) => {
    response.data.charge_log.forEach((item) => {
      if (item.channel_id === 21204) {
        setBlockChannel(false);
      }
    });
  };

  const fetchPaymentDetails = () => {
    setShowUILoader(true);
    axios(serverUrl + 'payment/get_detail', {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        token: btoa(authUserId + '|' + encryptedToken)
      },
      data: { booking_id: bookingId }
    })
      .then(response => {
        if (response.status === 200) {
          setPaymentLog(response.data);
          setNoData(false);
          setBlockChannel(true);
          if (response.data.charge_log.length === 0 || blockChannelFunction(response)) {
            setBlockChannel(false);
          }
          if (response.data.charge_log.length === 0) {
            setNoData(true);
          }
          if (response.data.message && response.data.message.name && response.data.message.name[0]) {
            showMessage('error', response.data.message.name[0]);
          }
        }
        setShowUILoader(false);
      })
      .catch(error => {
        console.log(error);
        setShowUILoader(false);
      });
  };

  const reInitiateCharge = () => {
    setShowUILoader(true);
    axios(serverUrl + 'payment/re_initiate_charge', {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        token: btoa(authUserId + '|' + encryptedToken)
      },
      data: { booking_id: bookingId }
    })
      .then(response => {
        if (response.status === 200) {
          fetchPaymentDetails();
        } else {
          if (response.data.message && response.data.message.name && response.data.message.name[0]) {
            showMessage('error', response.data.message.name[0]);
          }
        }
        setShowUILoader(false);
      })
      .catch(error => {
        console.log(error);
        setShowUILoader(false);
      });
  };

  const renderLogList = () => {
    return paymentLog.charge_log.map((val, id) => (
      <div className="table_row border_t_1 border_color_1 text-start" key={id}>
        <div className="tabcel align_middle pad10">
          <div className="ovr m_b_5">
            <div className="ovr fnt12 margtop5 bld" title="Booking ID">
              {val.common_booking_id}
            </div>
          </div>
        </div>
        <div className="tabcel align_middle pad10">
          <div className="ovr m_b_5">
            <div className="ovr fnt12 margtop5 bld" title="Amount">
              {val.amount}
            </div>
          </div>
        </div>
        <div className="tabcel align_middle pad10">
          <div className="ovr m_b_5">
            <div className="ovr fnt12 margtop5 bld" title="Currency">
              {val.currency}
            </div>
          </div>
        </div>
        <div className="tabcel align_middle pad10">
          <div className="ovr m_b_5">
            <div className="ovr fnt12 margtop5 bld" title="Status">
              {val.status}
            </div>
          </div>
        </div>
        <div className="tabcel align_middle pad10">
          <div className="ovr m_b_5">
            <div className="ovr fnt12 margtop5 bld" title="PG Message">
              {val.pg_status}
            </div>
          </div>
        </div>
        <div className="tabcel align_middle pad10">
          <div className="ovr m_b_5">
            <div className="ovr fnt12 margtop5 bld" title="Charged At">
              {val.date_time}
            </div>
          </div>
        </div>
      </div>
    ));
  };

  const customStyle = { display: 'flex', justifyContent: 'center', alignItems: 'center', width: '94vw', flexDirection: 'column', margin: '20px' };

  return (
    <React.Fragment>
      <div className="container_fluid topheading pad_lft_rht25 pad_top_bot15 text-start">
        <div className="row">
          <div className="col-xs">
            <div className="d-full-height justify-content-center fnt18 tu">Payment Logs</div>
          </div>
        </div>
      </div>
      <div className="container_fluid pad_lft_rht25 padtop10 bg2_12 boder_b_1 border_color_1">
        <div className="row gutters-5">
          <div className="col-xs-12 col-md-4 marg_bottom10">
            <div className="frm border_all_1 border_color_1">
              <input type="text" placeholder="Enter Booking ID" className="input pad_lft_rht5" onChange={handleValueChange} />
            </div>
          </div>
          <div className="col-xs-12 col-md-auto marg_bottom10">
            <div className="btn1 pad_top_bot7 pad_lft_rht15 cursor_p tc" onClick={fetchPaymentDetails}>
              <i className="fa fa-filter marg_right7"></i>Fetch Details
            </div>
          </div>
        </div>
      </div>
      <div className="container_fluid pad_lft_rht20 padtop25">
        {blockChannel && paymentLog.can_retry && (
          <div className="row float-end">
            {checkRole('vcc_charge_retry') ? (
              <div className="col-lg-12 col-md-auto marg_bottom10 float-right">
                <div className="btn1 pad_top_bot7 pad_lft_rht15 cursor_p tc float-right" onClick={reInitiateCharge}>
                  Re Initiate Charge
                </div>
              </div>
            ) : ''}
          </div>
        )}
        <div className="cover border_all_1 border_color_1 text-start">
          <div className="scrolly_auto">
            <div className="table_col table_fixed text-start">
              <div className="table_row bg2_8">
                <div className="tabcel align_middle pad10 tu bld wdhpx150">Booking ID</div>
                <div className="tabcel align_middle pad10 tu bld wdhpx150">Amount </div>
                <div className="tabcel align_middle pad10 tu bld wdhpx150">Currency</div>
                <div className="tabcel align_middle pad10 tu bld wdhpx150">Status</div>
                <div className="tabcel align_middle pad10 tu bld wdhpx150">PG Message</div>
                <div className="tabcel align_middle pad10 tu bld wdhpx150">Charge DateTime</div>
              </div>
              {renderLogList()}
              {noData && (
                <div style={customStyle}>
                  <img src="/images/no_result.png" alt="No Logs Found" />
                  <div className="ovr tc fnt16 bld">No Logs Found</div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default Dashboard;
